import React from 'react'
import { Col, Row } from 'reactstrap'

const SamplePackage = () => (
  <>
    <Row>
      <Col>
        <h6>Sample Packaging Information</h6>
      </Col>
    </Row>
  </>
)

export default SamplePackage
